import InsightsDashboard from "@/components/lunch_insights/InsightsDashboard";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_portal/lunch-admin/insights/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <div className="pageHeader">
        <h1>{t("SIDEBAR.LUNCH_INSIGHTS")}</h1>
      </div>
      <InsightsDashboard />
    </>
  );
}
